/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeesReferentialDto } from './FeesReferentialDto';
import {
    FeesReferentialDtoFromJSON,
    FeesReferentialDtoFromJSONTyped,
    FeesReferentialDtoToJSON,
    FeesReferentialDtoToJSONTyped,
} from './FeesReferentialDto';
import type { LoanConfigWithGuaranteeIdsDto } from './LoanConfigWithGuaranteeIdsDto';
import {
    LoanConfigWithGuaranteeIdsDtoFromJSON,
    LoanConfigWithGuaranteeIdsDtoFromJSONTyped,
    LoanConfigWithGuaranteeIdsDtoToJSON,
    LoanConfigWithGuaranteeIdsDtoToJSONTyped,
} from './LoanConfigWithGuaranteeIdsDto';
import type { CustomContractFunnelItemDto } from './CustomContractFunnelItemDto';
import {
    CustomContractFunnelItemDtoFromJSON,
    CustomContractFunnelItemDtoFromJSONTyped,
    CustomContractFunnelItemDtoToJSON,
    CustomContractFunnelItemDtoToJSONTyped,
} from './CustomContractFunnelItemDto';

/**
 * 
 * @export
 * @interface SelectFunnelsBorrowerCommandDto
 */
export interface SelectFunnelsBorrowerCommandDto {
    /**
     * 
     * @type {string}
     * @memberof SelectFunnelsBorrowerCommandDto
     */
    riskId: string;
    /**
     * 
     * @type {string}
     * @memberof SelectFunnelsBorrowerCommandDto
     */
    borrowerCommission?: string;
    /**
     * 
     * @type {Array<CustomContractFunnelItemDto>}
     * @memberof SelectFunnelsBorrowerCommandDto
     */
    contractFunnels?: Array<CustomContractFunnelItemDto>;
    /**
     * 
     * @type {Array<LoanConfigWithGuaranteeIdsDto>}
     * @memberof SelectFunnelsBorrowerCommandDto
     */
    loans?: Array<LoanConfigWithGuaranteeIdsDto>;
    /**
     * 
     * @type {Array<FeesReferentialDto>}
     * @memberof SelectFunnelsBorrowerCommandDto
     */
    globalFees?: Array<FeesReferentialDto>;
    /**
     * 
     * @type {string}
     * @memberof SelectFunnelsBorrowerCommandDto
     */
    modeLissageFraisIntermediation?: string;
}

/**
 * Check if a given object implements the SelectFunnelsBorrowerCommandDto interface.
 */
export function instanceOfSelectFunnelsBorrowerCommandDto(value: object): value is SelectFunnelsBorrowerCommandDto {
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    return true;
}

export function SelectFunnelsBorrowerCommandDtoFromJSON(json: any): SelectFunnelsBorrowerCommandDto {
    return SelectFunnelsBorrowerCommandDtoFromJSONTyped(json, false);
}

export function SelectFunnelsBorrowerCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectFunnelsBorrowerCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'riskId': json['riskId'],
        'borrowerCommission': json['borrowerCommission'] == null ? undefined : json['borrowerCommission'],
        'contractFunnels': json['contractFunnels'] == null ? undefined : ((json['contractFunnels'] as Array<any>).map(CustomContractFunnelItemDtoFromJSON)),
        'loans': json['loans'] == null ? undefined : ((json['loans'] as Array<any>).map(LoanConfigWithGuaranteeIdsDtoFromJSON)),
        'globalFees': json['globalFees'] == null ? undefined : ((json['globalFees'] as Array<any>).map(FeesReferentialDtoFromJSON)),
        'modeLissageFraisIntermediation': json['modeLissageFraisIntermediation'] == null ? undefined : json['modeLissageFraisIntermediation'],
    };
}

export function SelectFunnelsBorrowerCommandDtoToJSON(json: any): SelectFunnelsBorrowerCommandDto {
    return SelectFunnelsBorrowerCommandDtoToJSONTyped(json, false);
}

export function SelectFunnelsBorrowerCommandDtoToJSONTyped(value?: SelectFunnelsBorrowerCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskId': value['riskId'],
        'borrowerCommission': value['borrowerCommission'],
        'contractFunnels': value['contractFunnels'] == null ? undefined : ((value['contractFunnels'] as Array<any>).map(CustomContractFunnelItemDtoToJSON)),
        'loans': value['loans'] == null ? undefined : ((value['loans'] as Array<any>).map(LoanConfigWithGuaranteeIdsDtoToJSON)),
        'globalFees': value['globalFees'] == null ? undefined : ((value['globalFees'] as Array<any>).map(FeesReferentialDtoToJSON)),
        'modeLissageFraisIntermediation': value['modeLissageFraisIntermediation'],
    };
}

